import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../utils/axios-auth';
const initialState = {
    status: 'idle',
    data: null,
    error: null,
};
export const fetchWalkthroughStatus = createAsyncThunk('walkthrough/fetchStatus', async (_, { rejectWithValue }) => {
    try {
        const res = await axiosInstance.get('/walkthrough/status');
        if (!res.data?.success) {
            return rejectWithValue(res.data?.message || 'Failed to load walkthrough');
        }
        return res.data.data;
    }
    catch (e) {
        const msg = e && typeof e === 'object' && 'response' in e
            ? e.response?.data?.message
            : undefined;
        return rejectWithValue(msg || 'Failed to load walkthrough');
    }
});
export const saveWalkthroughProgressThunk = createAsyncThunk('walkthrough/saveProgress', async (payload, { rejectWithValue }) => {
    try {
        const res = await axiosInstance.post('/walkthrough/progress', {
            stepIndex: payload.stepIndex,
            stepKey: payload.stepKey,
        });
        if (!res.data?.success) {
            return rejectWithValue(res.data?.message || 'Failed to save progress');
        }
        return res.data.data;
    }
    catch (e) {
        const msg = e && typeof e === 'object' && 'response' in e
            ? e.response?.data?.message
            : undefined;
        return rejectWithValue(msg || 'Failed to save progress');
    }
});
export const completeWalkthroughThunk = createAsyncThunk('walkthrough/complete', async (opts, { rejectWithValue }) => {
    try {
        const res = await axiosInstance.post('/walkthrough/complete', { skipped: opts.skipped });
        if (!res.data?.success) {
            return rejectWithValue(res.data?.message || 'Failed to complete walkthrough');
        }
        return res.data.data;
    }
    catch (e) {
        const msg = e && typeof e === 'object' && 'response' in e
            ? e.response?.data?.message
            : undefined;
        return rejectWithValue(msg || 'Failed to complete walkthrough');
    }
});
export const resetWalkthroughThunk = createAsyncThunk('walkthrough/reset', async (_, { rejectWithValue }) => {
    try {
        const res = await axiosInstance.post('/walkthrough/reset');
        if (!res.data?.success) {
            return rejectWithValue(res.data?.message || 'Failed to reset walkthrough');
        }
        return res.data.data;
    }
    catch (e) {
        const msg = e && typeof e === 'object' && 'response' in e
            ? e.response?.data?.message
            : undefined;
        return rejectWithValue(msg || 'Failed to reset walkthrough');
    }
});
const walkthroughSlice = createSlice({
    name: 'walkthrough',
    initialState,
    reducers: {
        clearWalkthroughError(state) {
            state.error = null;
        },
        setWalkthroughLocal(state, action) {
            state.data = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWalkthroughStatus.pending, (state) => {
            state.status = 'loading';
            state.error = null;
        })
            .addCase(fetchWalkthroughStatus.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.data = action.payload;
        })
            .addCase(fetchWalkthroughStatus.rejected, (state, action) => {
            state.status = 'failed';
            state.error = String(action.payload ?? action.error.message ?? 'Error');
        })
            .addCase(saveWalkthroughProgressThunk.fulfilled, (state, action) => {
            state.data = action.payload;
        })
            .addCase(completeWalkthroughThunk.fulfilled, (state, action) => {
            state.data = action.payload;
        })
            .addCase(resetWalkthroughThunk.fulfilled, (state, action) => {
            state.data = action.payload;
        });
    },
});
export const { clearWalkthroughError, setWalkthroughLocal } = walkthroughSlice.actions;
export default walkthroughSlice.reducer;
